import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { Router } from '@angular/router';
import { NAVBAR_ASSORTMENT_ROUTE, NavItemModel } from '@libs/shared/models';
import { MobileNavigationComponent } from '../mobile-navigation';

@Component({
  selector: 'ui-mobile-navigation-route',
  imports: [
    MobileNavigationComponent,
  ],
  templateUrl: './mobile-navigation-route.component.html',
  styleUrl: './mobile-navigation-route.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileNavigationRouteComponent {
  public currentCategoryId: InputSignal<string | undefined> = input();

  public constructor(private readonly router: Router) {
  }

  public async onCategoryChange(navItem: NavItemModel): Promise<void> {
    if (navItem.name === 'primary') {
      await this.router.navigateByUrl(`/${NAVBAR_ASSORTMENT_ROUTE}`);
    } else if (navItem.id && navItem.children?.length) {
      await this.router.navigateByUrl(`/${NAVBAR_ASSORTMENT_ROUTE}/${navItem.id}`);
    }
  }
}
